import { __awaiter, __generator } from "tslib";
import { BookButtonSettingsKeys, GeneralLinkDestinationOptions, SelectedServiceLinkDestinationOptions, } from '@wix/bookings-app-builder-settings-const/dist/src/BookButton/Settings.const';
import { navigateToBookingsCalendarPage, navigateToCalendarPage, navigateToBookingsServicePage, navigateToServiceList, } from '@wix/bookings-catalog-calendar-viewer-navigation';
import { OfferingType } from '@wix/bookings-uou-domain/dist/src';
import { WidgetReferralInfo } from '../bi-logger/bi.const';
import { isExperimentEnabled } from '../utils/experiment-enabled';
var BookButtonViewModel = /** @class */ (function () {
    function BookButtonViewModel(_a) {
        var $button = _a.$button, controllerConfig = _a.controllerConfig, biLogger = _a.biLogger, wixCodeApi = _a.wixCodeApi, platformAPIs = _a.platformAPIs, experiments = _a.experiments;
        this.wixCodeApi = wixCodeApi;
        this.platformAPIs = platformAPIs;
        this.$button = $button;
        this.controllerConfig = controllerConfig;
        this.biLogger = biLogger;
        this.experiments = experiments;
        this.initListener();
    }
    BookButtonViewModel.prototype.shouldNavigateToCalendar = function () {
        var service = this.controllerConfig[BookButtonSettingsKeys.SELECTED_SERVICE];
        var isCourseOffering = service.type === OfferingType.COURSE;
        var isBookable = service.isBookable;
        var isNavigateToCalendar = this.controllerConfig[BookButtonSettingsKeys.SELECTED_SERVICE_LINK_DESTINATION] === SelectedServiceLinkDestinationOptions.CALENDAR;
        return isBookable && !isCourseOffering && isNavigateToCalendar;
    };
    BookButtonViewModel.prototype.initListener = function () {
        var _this = this;
        this.$button.onClick(function () { return __awaiter(_this, void 0, void 0, function () {
            var service;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.shouldNavigateToServiceList()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.navigateToServiceList()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        service = this.controllerConfig[BookButtonSettingsKeys.SELECTED_SERVICE];
                        return [4 /*yield*/, this.navigateToSpecificService(service)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    BookButtonViewModel.prototype.shouldNavigateToServiceList = function () {
        var linkDestination = this.controllerConfig[BookButtonSettingsKeys.LINK_DESTINATION];
        return (!linkDestination ||
            linkDestination === GeneralLinkDestinationOptions.SERVICE_LIST);
    };
    BookButtonViewModel.prototype.navigateToServiceList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.biLogger.sendBookButtonClickEvent({
                            isPendingApproval: null,
                            service_id: null,
                            type: null,
                        })];
                    case 1:
                        _a.sent();
                        this.biLogger.sendInitalIntent();
                        return [2 /*return*/, navigateToServiceList({ wixCodeApi: this.wixCodeApi })];
                }
            });
        });
    };
    BookButtonViewModel.prototype.navigateToSpecificService = function (service) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!service) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.biLogger.sendBookButtonClickEvent({
                                isPendingApproval: service.isPendingApproval,
                                service_id: service.id,
                                type: service.type,
                            })];
                    case 1:
                        _a.sent();
                        this.biLogger.sendInitalIntent(service);
                        if (this.shouldNavigateToCalendar()) {
                            return [2 /*return*/, this.navigateToCalendarPage(service)];
                        }
                        return [2 /*return*/, this.navigateToServicePage(service)];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BookButtonViewModel.prototype.navigateToCalendarPage = function (service) {
        return __awaiter(this, void 0, void 0, function () {
            var isBookFlowSettingsEnabled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isExperimentEnabled('specs.bookings.BookFlowSettings', this.experiments)];
                    case 1:
                        isBookFlowSettingsEnabled = _a.sent();
                        if (!isBookFlowSettingsEnabled) return [3 /*break*/, 3];
                        return [4 /*yield*/, navigateToCalendarPage(this.wixCodeApi, this.platformAPIs, {
                                serviceSlugOrBasket: service.slug,
                                navigationContext: {
                                    referral: WidgetReferralInfo.BOOK_BUTTON,
                                },
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, navigateToBookingsCalendarPage(this.wixCodeApi, this.platformAPIs, {
                            serviceSlugOrBasket: service.slug,
                            navigationContext: {
                                referral: WidgetReferralInfo.BOOK_BUTTON,
                            },
                        })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BookButtonViewModel.prototype.navigateToServicePage = function (service) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, navigateToBookingsServicePage(this.wixCodeApi, {
                            serviceSlug: service.slug,
                            referral: WidgetReferralInfo.BOOK_BUTTON,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return BookButtonViewModel;
}());
export { BookButtonViewModel };
//# sourceMappingURL=book-button.view-model.js.map